module.exports = __webpack_public_path__ + "assets/img/array1.bd58a623.svg";